import React from 'react';
import { useField } from 'formik';
import { makeStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { requiredFields } from '../FormPage/FormPage';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',

    '& .MuiInputBase-root': {
      minWidth: 300,
      width: '40%',
    }
  },
}));

type InputFieldProps = {
  label: React.ReactNode,
  name: string,
  required?: boolean,
  type?: string,
}

//"required" prop is really just to show/hide the (optional) label
const ConnectedInputField = ({ label, name, required, type }: InputFieldProps) => {
  const classes = useStyles();
  const [field, meta] = useField(name);
  const isRequired = required || requiredFields[name];
  return (
    <TextField
      {...field}
          className={classes.root}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
          onKeyPress={(ev) => {
              if (type === 'number2') {
                  if (isNaN(parseInt(ev.key))) {
                      ev.preventDefault();
                  }
              }
          }}
      label={
        <React.Fragment>
          {label} {isRequired ? '' : <Typography variant="caption">(optional)</Typography>}
        </React.Fragment>
      }
      margin="normal"
      name={name}
      type={type}
          variant="outlined"
      InputLabelProps={{
              shrink: true,
          }}
    />
  )
}

export default ConnectedInputField;
